module.exports = __webpack_public_path__ + "img/insurance-logo-11.bebe5d6c.png";